
import React from 'react';
import { useUser } from '@/context/UserContext';
import Index from './Index';

const HomePage: React.FC = () => {
  const { isLoading } = useUser();
  
  // Show loading state if authentication status is still being determined
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-hormony-coral"></div>
      </div>
    );
  }
  
  // Show the landing page for all users (authenticated or not)
  return <Index />;
};

export default HomePage;
